import { message as antMessage } from 'antd';

const success = (message: string) => {
  antMessage.success(message);
};

const error = (message: string) => {
  antMessage.error(message);
};

const warning = (message: string) => {
  antMessage.warning(message);
};

export default {
  sucess: success,
  error,
  warning,
};
